import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, NavigationExtras } from '@angular/router';
import { Message } from 'primeng/primeng';

import { HomeService } from '../home/home.service';
import { MainService } from '../main.service';
import { environment } from '../../environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.css']
})

export class ExternalLoginComponent implements OnInit {

  loginData: any;
  options: {};
  activityOptions: {};
  userOptions: {};
  message: string;
  username: string;
  password: string;
  session: string;
  imageData: string;
  activityResponce: any;
  dataResponce: any;
  msgs: Message[];
  growl: Message[];
  date = new Date();
  isClient: boolean;
  clickedOnce: boolean;

  currentDate = new Date();
  year = this.currentDate.getFullYear();
  token: {};

  

  setMessage() {
    this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
  }

  loginEventHandler(event) {
    if (event.keyCode == 13) {
      this.login();
    }
  }

  /////////////////  hard coded user login

  // loginDetails() {
  //   this.loginData = {};
  //   console.log("this.username", this.username);
  //   console.log("this.password", this.password);

  //   this.loginData.session="Abcdedfghijklmnopqrstuvwxyz12345";

  //   localStorage.setItem('isTour', 'false');
  //   if(this.username == "test@123.com" && this.password == "test"){
  //     if (this.loginData.session != undefined) {
  //       localStorage.setItem('jiraSession', JSON.stringify(this.loginData.session.value));
  //       localStorage.setItem("fromDate", "");
  //       localStorage.setItem("toDate", "");
  //       localStorage.setItem("component", "");
  //       this.session = this.loginData.session.value;
  //       // this.userMetaData(this.session);
  //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
  //       localStorage.setItem('userEmail', 'isuru.dissanayake@directfn.com');
  //       localStorage.setItem("sessionExpireTime", "");

  //       this.setMessage();

  //       this.authServiceReq();

  //     }
  //     else if (this.loginData.errorMessages[0] == 'Login denied') {

  //       this.clickedOnce = false;
  //       this.growl = [];
  //       this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
  //     }
  //     else if (this.loginData.errorMessages[0] == 'Login failed') {

  //       this.clickedOnce = false;
  //       this.growl = [];
  //       this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
  //     }
  //   }

  // }

  /////////// using database user login

  loginDetails() {
    this.loginData = {};
    this.isClient = this.username.includes("@");

    this.mainService.authExternalUser(this.options).then(login => {
      this.loginData = login[0];

      if(this.loginData.sessionId != undefined){
        localStorage.setItem('jiraSession', this.loginData.sessionId);
        localStorage.setItem("fromDate", "");
        localStorage.setItem("toDate", "");
        localStorage.setItem("component", "");
        this.session = this.loginData.sessionId;
        // this.userMetaData(this.session);
        localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
        localStorage.setItem('userEmail', this.loginData.email);
        localStorage.setItem("sessionExpireTime", "");
        localStorage.setItem('userName',this.loginData.displayName);
        localStorage.setItem('externalUser', 'true');

        

        this.setMessage();

        this.authServiceReq();
      }else if (this.loginData.errorMessage == 'Login Denied') {
        console.log("Login denied");
        this.clickedOnce = false;
        this.growl = [];
        this.growl.push({ severity: 'warn', summary: 'Login Denied', detail: 'CAPTCHA CHALLENGE :  Please Contact Admin or Re-Login and Try Again !' });
      }
      else if (this.loginData.errorMessage == 'Login Failed') {
        console.log("Login failed");
        this.clickedOnce = false;
        this.growl = [];
        this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
      }

      // if (this.loginData === undefined) {
      //   // Your code logic when this.loginData is undefined
      //   console.log("this.loginData is undefined");
      // } else {
      //   // Your code logic when this.loginData is defined
      //   console.log("this.loginData is defined");
      // }
    });

    // localStorage.setItem('isTour', 'false');
    // console.log(this.isClient);
    // if (!this.isClient) {
    //   this.mainService.clientLogin(this.options).then(login => {
    //     if (login.length == 1) {
    //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
    //       localStorage.setItem('userEmail', login[0].name);
    //       localStorage.setItem('userName', login[0].name);
    //       localStorage.setItem('login', 'true');

    //       this.setMessage();

    //       this.authServiceReq();

    //     } else {

    //       this.growl = [];
    //       this.growl.push({ severity: 'error', summary: 'Invalid Login' });
    //     }
    //   });

    // } else {
    //   this.mainService.userLogin(this.options).then(login => {
    //     this.loginData = login;

    //     if (this.loginData.session != undefined) {
    //       localStorage.setItem('jiraSession', JSON.stringify(this.loginData.session.value));
    //       localStorage.setItem("fromDate", "");
    //       localStorage.setItem("toDate", "");
    //       localStorage.setItem("component", "");
    //       this.session = this.loginData.session.value;
    //       // this.userMetaData(this.session);
    //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
    //       localStorage.setItem('userEmail', this.username);
    //       localStorage.setItem("sessionExpireTime", "");

    //       this.setMessage();

    //       this.authServiceReq();

    //     }
    //     else if (this.loginData.errorMessages[0] == 'Login denied') {

    //       this.clickedOnce = false;
    //       this.growl = [];
    //       this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
    //     }
    //     else if (this.loginData.errorMessages[0] == 'Login failed') {

    //       this.clickedOnce = false;
    //       this.growl = [];
    //       this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
    //     }
    //   });
    // }

  }

  // loginDetails() {
  //   this.loginData = {};
  //   this.isClient = this.username.includes("@");
  //   console.log("this.username" , this.username);
  //   console.log("this.password" , this.password);

  //   localStorage.setItem('isTour', 'false');
  //   console.log(this.isClient);
  //   if (!this.isClient) {
  //     this.mainService.clientLogin(this.options).then(login => {
  //       if (login.length == 1) {
  //         localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
  //         localStorage.setItem('userEmail', login[0].name);
  //         localStorage.setItem('userName', login[0].name);
  //         localStorage.setItem('login', 'true');

  //         this.setMessage();

  //         this.authServiceReq();

  //       } else {

  //         this.growl = [];
  //         this.growl.push({ severity: 'error', summary: 'Invalid Login' });
  //       }
  //     });

  //   } else {
  //     this.mainService.userLogin(this.options).then(login => {
  //       this.loginData = login;

  //       if (this.loginData.session != undefined) {
  //         localStorage.setItem('jiraSession', JSON.stringify(this.loginData.session.value));
  //         localStorage.setItem("fromDate", "");
  //         localStorage.setItem("toDate", "");
  //         localStorage.setItem("component", "");
  //         this.session = this.loginData.session.value;
  //         // this.userMetaData(this.session);
  //         localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
  //         localStorage.setItem('userEmail', this.username);
  //         localStorage.setItem("sessionExpireTime", "");

  //         this.setMessage();

  //         this.authServiceReq();

  //       }
  //       else if (this.loginData.errorMessages[0] == 'Login denied') {

  //         this.clickedOnce = false;
  //         this.growl = [];
  //         this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
  //       }
  //       else if (this.loginData.errorMessages[0] == 'Login failed') {

  //         this.clickedOnce = false;
  //         this.growl = [];
  //         this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
  //       }
  //     });
  //   }

  // }

  authServiceReq() {
    this.authService.login().subscribe(() => {
      if (this.authService.isLoggedIn) {
        // Get the redirect URL from our auth service
        // If no redirect has been set, use the default
        let redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/';
        this.growl = [];
        this.growl.push({ severity: 'success', summary: 'Log In Successful !' });
        // Set our navigation extras object
        // that passes on our global query params and fragment
        let navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true
        };
        this.activityOptions = {
          user: this.username,
          action: "Login",
          file: "--"
        };

        this.homeService.sendActivity(this.activityOptions).then(res => {
          this.activityResponce = res;
        });

        // Redirect the user to previous location
        setTimeout(() => {
          this.router.navigate(['/Home']);
        },
          500);


      }
    });
  }


  login() {
    this.message = 'Trying to log in ...';

    this.options = {
      us: this.username,
      ps: this.password
    };


    this.clickedOnce = true;

    this.loginDetails();

    // if (this.username.includes("@")) {
    //   this.userData();
    // }
  }

  userData() {
    this.mainService.getUserEmail(this.options).then(res => {
      this.dataResponce = res;
      localStorage.setItem('userName', this.dataResponce[0].name);
      localStorage.setItem('is_Admin', this.dataResponce[0].is_admin);
    });
  }

  userMetaData(sessionData) {

    this.userOptions = {
      username: this.username,
      session: sessionData
    };

    this.mainService.getUserDetails(this.userOptions).then(res => {
      this.imageData = JSON.stringify(res.avatarUrls);
      this.imageData = (((this.imageData.split(",", 1))[0].split(":"))[2].replace("\"", ""));
      this.imageData = this.imageData.replace("}", "");
      localStorage.setItem('userName', res.displayName);
      localStorage.setItem('userImage', this.imageData);
    });
  }



  constructor(public authService: AuthService, public router: Router, private mainService: MainService, private homeService: HomeService) {

  }

  // createLoginSessionInMicrosoft(){
  //   // this.loginData = {};
  //   // this.isClient = this.username.includes("@");
  //   // localStorage.setItem('isTour', 'false');
  //   console.log("createLoginSessionInMicrosoft");
  //   const paramName = 'token';
  //   const paramValue = this.getURLParameter(paramName);

  //   if(paramValue != null){
  //     console.log("paramValue != null");
  //     this.token = {
  //       token: paramValue
  //     };
  //     // console.log("this.token['token']", this.token['token']);
  //     this.mainService.createLoginSessionInMicrosoft(this.token).then(mslogin =>{
  //       this.loginData = mslogin;
  //       this.username = mslogin.displayName;
  //       // console.log("this.username", this.username);
  //       // console.log("this.loginData", this.loginData);
  //       // console.log("this.loginData.displayName", this.loginData.displayName);

  //       if(this.loginData.id != undefined){
  //         localStorage.setItem('jiraSession', this.loginData.id);
  //         localStorage.setItem("fromDate", "");
  //         localStorage.setItem("toDate", "");
  //         localStorage.setItem("component", "");
  //         this.session = this.loginData.id;
  //         // this.userMetaData(this.session);
  //         localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
  //         localStorage.setItem('userEmail', this.loginData.mail);
  //         localStorage.setItem("sessionExpireTime", "");
  //         localStorage.setItem('userName', this.username);

  //         this.setMessage();
  //         this.authServiceReq();
  //       }
  //       else if (this.loginData.errorMessages[0] == 'Login denied') {

  //         this.clickedOnce = false;
  //         this.growl = [];
  //         this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
  //       }
  //       else if (this.loginData.errorMessages[0] == 'Login failed') {

  //         this.clickedOnce = false;
  //         this.growl = [];
  //         this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
  //       }

  //     });
  //   }else if(paramValue == null){  
  //     // window.location.href = "https://localhost:3000/?backUrl=http://localhost:4300/Login";
  //     window.location.href = authApp + "/?backUrl=" + dfnRMApp + "/login";
  //   }
  // }

  getURLParameter(name) {
    const urlSeachParams = new URLSearchParams(window.location.search);
    return urlSeachParams.get(name);
  }

  MSautho(){
    // console.log("MSautho");
  }

  ngOnInit() {
    // this.MSautho();
    // this.createLoginSessionInMicrosoft();
  }


}
